import React from 'react'

const PlusButton = ({ onClick}) => (
  <button className='bg-none p-0 cursor-pointer' onClick={onClick}>
    <svg width="25" height="24" xmlns="http://www.w3.org/2000/svg">
      <path fill="#85D6FF" d="M12.5 0c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm0 5.143a.857.857 0 0 0-.857.857l-.001 5.142H6.5a.857.857 0 0 0 0 1.715h5.142V18a.857.857 0 0 0 1.715 0v-5.143H18.5a.857.857 0 0 0 0-1.714l-5.143-.001V6a.857.857 0 0 0-.857-.857z" fillRule="evenodd"/>
    </svg>
  </button>
)

export default PlusButton
